import { googleAPI } from './google';
import { wiseAPI } from './wise';
import { revolutAPI } from './revolut';
import { bridgeAPI } from './bridge';
import { openbankingAPI } from './openbanking';
import { xeroAPI } from './xero';
import { uplistingAPI, smoobuAPI, hostawayAPI } from './channelManagers';
import { brosAPI } from './bros';

// Integrations API (aggregated)
export const integrationsAPI = {
  google: googleAPI,
  wise: wiseAPI,
  revolut: revolutAPI,
  bridge: bridgeAPI,
  openbanking: openbankingAPI,
  xero: xeroAPI,
  uplisting: uplistingAPI,
  smoobu: smoobuAPI,
  hostaway: hostawayAPI,
  bros: brosAPI,
};
